import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { ROUTE_KEYS } from '../../utils/constants';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(ROUTE_KEYS.HOME, { replace: true });
  }, []);
  return <div />;
};

export default Dashboard;
